import { render, staticRenderFns } from "./SocialPostsTableAnnonces.vue?vue&type=template&id=e78df4de&scoped=true&"
import script from "./SocialPostsTableAnnonces.vue?vue&type=script&lang=js&"
export * from "./SocialPostsTableAnnonces.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostsTableAnnonces.vue?vue&type=style&index=0&id=e78df4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78df4de",
  null
  
)

export default component.exports